import {Component, Element, h, Host, State} from '@stencil/core';

@Component({
  tag: 'nest-shell',
  styleUrl: 'nest-shell.scss',
  shadow: true,
})
export class NestShell {
  @Element() host: HTMLElement;

  @State() shellHeader: Element;
  @State() shellStart: Element;
  @State() shellEnd: Element;

  componentWillLoad() {
    this.shellHeader = this.host.querySelector("[slot='shell-header']")
    this.shellStart = this.host.querySelector("[slot='shell-start']")
    this.shellEnd = this.host.querySelector("[slot='shell-end']")
  }

  render() {
    return (
      <Host>
        {this.shellHeader && (
          <slot name='shell-header'/>
        )}

        <div class={`nest-shell ${this.shellHeader ? 'pt-16': ''}`}>
          <slot key="panel" name='shell-panel' />
          <div class='flex ml-16'>
            {this.shellStart && (
              <div class='grow-0'>
                <slot key="shell-start" name='shell-start'/>
              </div>
            )}
            <div class='grow'>
              <slot/>
            </div>

            {this.shellEnd && (
              <div class='grow-0'>
                <slot key="shell-end" name='shell-end'/>
              </div>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
